import o from "./ghl-ui.es822.js";
import t from "./ghl-ui.es824.js";
import r from "./ghl-ui.es825.js";
import a from "./ghl-ui.es826.js";
import m from "./ghl-ui.es1458.js";
var e = {
  code: "fr-CA",
  formatDistance: o,
  formatLong: m,
  formatRelative: t,
  localize: r,
  match: a,
  // Unique for fr-CA
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const s = e;
export {
  s as default
};
